import React, { FC, useCallback, useMemo, useState } from 'react';
import { useFormState, useWatch } from 'react-hook-form';
import { AlgorithmSourcesFormModal } from './AlgorithmSourcesFormModal';
import { AlgorithmSources } from './AlgorithmSources';
import { warningAlgorithmDirty } from '../../../common/form';
import { AlgorithmType } from '../schema/zAlgorithmType';

interface AlgorithmFormSourcesProps {
  isAlgorithmDirty: boolean;
  expanded: boolean;
  onToggle?: (expanded: boolean) => void;
}

export const AlgorithmFormSources: FC<AlgorithmFormSourcesProps> = (props) => {
  const { isAlgorithmDirty } = props;
  const [algorithmId, algorithmTypeCode] = useWatch({
    name: ['id', 'typeCode'],
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = useCallback(() => {
    if (isAlgorithmDirty) {
      warningAlgorithmDirty();
    } else {
      setIsModalOpen(true);
    }
  }, [isAlgorithmDirty, setIsModalOpen]);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  const hasError = Boolean(useFormState().errors.sources);

  const isInsert = useMemo(
    () => algorithmTypeCode === AlgorithmType.INSERT,
    [algorithmTypeCode]
  );

  return (
    <>
      <AlgorithmSources
        {...props}
        algorithmId={algorithmId}
        onEditButtonClick={isInsert && algorithmId ? showModal : undefined}
        hasError={hasError}
        isLoading={isLoading}
      />
      {isModalOpen && (
        <AlgorithmSourcesFormModal
          algorithmId={algorithmId}
          onClose={handleCancel}
          onLoadingStateChange={setIsLoading}
        />
      )}
    </>
  );
};
